module.exports = __webpack_public_path__ + "img/register-gift.b7fa735f.png";